<app-hero-card [leadIn]="'403'" [header]="'Not authorized'" [followupText]="'Please contact the adminstrators.'">
  <div class="col-12 mt-5 text-center">
    <i class="pi pi-fw pi-arrow-left text-blue-500 mr-2" style="vertical-align: center"></i
    ><a href="/" class="text-blue-500">Go to Dashboard</a>
  </div></app-hero-card
>
